/** Static user intents only. Never register resource IDs, names, messages or URLs. */
export const applicationToastOperations = [
  "account.delete",
  "account.display_name_update",
  "account.revoke_sessions",
  "account_view_mode.update",
  "annotation_queue.load",
  "annotation_queue.save",
  "annotation_queue_assignment.remove",
  "audit_log.export",
  "automation.create",
  "automation.delete",
  "automation.update",
  "background_migration.retry",
  "billing_checkout.start",
  "billing_discount.apply",
  "billing_plan.change",
  "billing_plan.keep",
  "billing_portal.open",
  "blob_storage.save",
  "blob_storage.validate",
  "correction.delete",
  "dashboard.clone",
  "dashboard.create",
  "dashboard.delete",
  "dashboard.import",
  "dashboard.query",
  "dashboard.update",
  "dashboard_card.copy",
  "dashboard_card.import",
  "dashboard_card.paste",
  "dashboard_chart.add",
  "dashboard_filters.update",
  "dashboard_home.update",
  "dataset.add_observations",
  "dataset.bulk_delete",
  "dataset_annotation.navigate",
  "dataset_item.prepare",
  "dataset_item.stringify",
  "dataset_item_media.upload",
  "dataset_items.import",
  "dataset_version_timestamp.copy",
  "default_evaluation_model.update",
  "evaluation.queue",
  "evaluation_model.delete",
  "evaluation_model.set",
  "evaluation_model.update",
  "evaluation_rule.create",
  "evaluation_rule.update",
  "evaluator.bulk_delete",
  "evaluator.clone",
  "evaluator.create",
  "evaluator.delete",
  "evaluator.navigate",
  "evaluator.reactivate",
  "evaluator.save",
  "evaluator.test",
  "evaluator.update",
  "evaluator_backfill.estimate",
  "evaluator_backfill.run",
  "evaluator_code.format",
  "evaluator_description.generate",
  "evaluator_name.generate",
  "evaluator_rule.attach",
  "evaluator_rule.create",
  "evaluator_rule.delete",
  "evaluator_rule.detach",
  "evaluator_rule.estimate_activation",
  "evaluator_rule.status_update",
  "evaluator_rule.update",
  "evaluator_rule_name.generate",
  "evaluator_saved_dialog.dismiss",
  "evaluator_saved_dialog.finish",
  "evaluator_variable.extract",
  "experiment.create",
  "experiment.trigger",
  "export.queue",
  "external_media_storage.delete",
  "external_media_storage.save",
  "external_media_storage.test",
  "filter_ai.generate",
  "gateway_configuration.save",
  "in_app_agent_conversation.delete",
  "in_app_agent_conversations.load",
  "in_app_agent_feedback.save",
  "in_app_agent_run.stop",
  "in_app_agent_session_id.copy",
  "json_schema.prettify",
  "media.resolveExternalMedia",
  "model.create",
  "model.update",
  "monitor.create",
  "monitor.delete",
  "monitor.pause",
  "monitor.resume",
  "monitor.status_update",
  "monitor.update",
  "monitor_title.generate",
  "mutation.execute",
  "observation.add_to_annotation_queue",
  "observation.download",
  "observation.parse",
  "onboarding.complete",
  "onboarding.continue",
  "onboarding_prompt.copy",
  "organization.delete",
  "organization_feature_preview.update",
  "organization_role.update",
  "playground.execute",
  "playground_schema.prettify",
  "playground_tool.prettify",
  "playground_window.add",
  "playground_window.remove",
  "project.transfer",
  "project_api_key.create",
  "project_default_model.update",
  "project_role.update",
  "prompt.copy",
  "prompt.export",
  "prompt_tags.update",
  "query.execute",
  "read_path.switch",
  "remote_experiment.configure",
  "remote_experiment.delete",
  "remote_experiment.trigger",
  "remote_experiment.update",
  "saved_view.apply",
  "saved_view.default_clear",
  "saved_view.default_set",
  "saved_view.permalink_copy",
  "saved_view.permalink_generate",
  "saved_view.update",
  "score.bulk_delete",
  "score.create",
  "score.delete",
  "score.update",
  "score_category.create",
  "session.add_to_annotation_queue",
  "sharing.disable",
  "sharing.enable",
  "sharing.update",
  "skill_draft.resume",
  "skill_file.create",
  "skill_file.move",
  "skill_file.restore",
  "skill_files.add",
  "skill_folder.create",
  "skill_folder.move",
  "skill_labels.update",
  "skill_tags.update",
  "skill_version.create",
  "skill_version.download",
  "skills.import",
  "slack.connect",
  "slack.disconnect",
  "slack.test_message_send",
  "spend_alert.create",
  "spend_alert.delete",
  "spend_alert.update",
  "sso.configure",
  "sso.disable",
  "sso.update",
  "subscription.cancel",
  "subscription.reactivate",
  "support_attachment.upload",
  "support_request.submit",
  "topics.load",
  "trace.add_to_annotation_queue",
  "trace.bulk_delete",
  "trace.delete",
  "trace.download",
  "trace.parse",
  "trace_log.copy",
  "user_feature_preview.update",
  "verified_domain.add",
  "verified_domain.remove",
  "verified_domain.verify",
  "web_callout.invoke",
  "web_callout_endpoint.create",
  "web_callout_endpoint.delete",
  "web_callout_endpoint.update",
  "webhook_secret.regenerate",
  "widget.clone",
  "widget.copy",
  "widget.create",
  "widget.delete",
  "widget.download",
  "widget.import",
  "widget.paste",
  "widget.update",
  "widget.validate",
] as const;

export type ApplicationToastOperation =
  (typeof applicationToastOperations)[number];
